/* rrd-nav.js 30 Sep 2026, min of build/src */
(() => {
if (window.__rrdNav) return;
window.__rrdNav = 1;
const OPEN = 300, SWITCH = 150, CLOSE = 400;
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const send = (p) => {
try {
if (typeof window.gtag === 'function') window.gtag('event', 'nav_click', p);
else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'nav_click' }, p));
} catch (err) {  }
};
const nav = document.querySelector('[data-rrd-nav]');
let cur = null, tOpen = 0, tClose = 0, pt = 'mouse';
const btn = (i) => i.querySelector('[data-rrd-toggle]');
const eager = (i) => $$('img[loading="lazy"]', i).forEach((m) => { m.loading = 'eager'; });
function open(i, hov) {
clearTimeout(tClose);
if (cur && cur !== i) close(cur);
eager(i);
nav.style.setProperty('--rrd-panel-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
i.classList.add('is-open');
btn(i).setAttribute('aria-expanded', 'true');
i._hov = hov ? Date.now() : 0;
cur = i;
$$('[data-rrd-disc].is-open').forEach((w) => w._close && w._close());
}
function close(i, focus) {
i = i || cur;
if (!i) return;
i.classList.remove('is-open');
btn(i).setAttribute('aria-expanded', 'false');
i._hov = 0;
if (cur === i) cur = null;
if (focus) btn(i).focus();
}
if (nav) {
$$('[data-rrd-item]', nav).filter(btn).forEach((i) => {
const top = i.querySelector('.rn-tp');
i.addEventListener('pointerenter', (e) => {
pt = e.pointerType;
if (pt !== 'mouse') return;
clearTimeout(tClose); clearTimeout(tOpen);
if (cur === i) return;
eager(i);
tOpen = setTimeout(() => open(i, 1), cur ? SWITCH : OPEN);
});
i.addEventListener('pointerleave', (e) => {
if (e.pointerType !== 'mouse') return;
clearTimeout(tOpen);
if (cur && cur._hov) tClose = setTimeout(() => close(), CLOSE);
});
btn(i).addEventListener('click', () => {
clearTimeout(tOpen);
if (cur === i && !(pt === 'mouse' && Date.now() - (i._hov || 0) < 800)) close(i); else open(i);
});
top.addEventListener('pointerdown', (e) => { pt = e.pointerType; });
top.addEventListener('click', (e) => {
if ((pt === 'touch' || pt === 'pen') && cur !== i) { e.preventDefault(); open(i); }
});
i.addEventListener('focusout', (e) => {
if (cur === i && !i.contains(e.relatedTarget) && !(e.relatedTarget === null && i.matches(':hover'))) close(i);
});
});
document.addEventListener('keydown', (e) => {
pt = 'key';
if (e.key === 'Escape' && cur) close(cur, cur.contains(document.activeElement));
});
document.addEventListener('pointerdown', (e) => { if (cur && !cur.contains(e.target)) close(cur); });
const sh = document.querySelector('.section-header');
window.addEventListener('scroll', () => {
if (cur && sh && sh.classList.contains('shopify-section-header-hidden')) close(cur);
}, { passive: true });
const mq = window.matchMedia('(max-width: 989.98px)'), mf = (m) => { if (m.matches) close(cur); };
mq.addEventListener ? mq.addEventListener('change', mf) : mq.addListener(mf);
const mp = nav.querySelector('[data-rrd-mphone]');
const hi = document.querySelector('.header > .header__icons');
if (mp && hi) hi.insertBefore(mp, hi.firstChild);
}
$$('[data-rrd-disc]').forEach((w) => {
const b = w.querySelector('[data-rrd-disc-btn]');
let tw = 0;
w._close = () => { clearTimeout(tw); if (w.classList.contains('is-open')) set(false); };
const set = (o, f, hov) => {
if (o && cur) close(cur);
w.classList.toggle('is-open', o); b.setAttribute('aria-expanded', String(o));
w._hov = o && hov ? Date.now() : 0;
if (!o && f) b.focus();
};
w.addEventListener('pointerenter', (e) => {
if (e.pointerType !== 'mouse') return;
clearTimeout(tw);
if (!w.classList.contains('is-open')) tw = setTimeout(() => set(true, 0, 1), OPEN);
});
w.addEventListener('pointerleave', (e) => {
if (e.pointerType !== 'mouse') return;
clearTimeout(tw);
if (w._hov) tw = setTimeout(() => set(false), CLOSE);
});
b.addEventListener('click', () => {
clearTimeout(tw);
const o = w.classList.contains('is-open');
set(!o || (w._hov && Date.now() - w._hov < 800));
});
w.addEventListener('keydown', (e) => { if (e.key === 'Escape' && w.classList.contains('is-open')) set(false, true); });
w.addEventListener('focusout', (e) => { if (e.relatedTarget && !w.contains(e.relatedTarget)) set(false); });
document.addEventListener('pointerdown', (e) => { if (!w.contains(e.target)) set(false); });
});
const dr = document.querySelector('[data-rrd-drawer]');
if (dr) {
const v3 = dr.classList.contains('rd-v3');
const hdx = dr.closest('header-drawer');
const main = hdx && hdx.querySelector('details');
const sm = main && main.querySelector('summary');
const md = document.getElementById('menu-drawer');
dr.addEventListener('click', (e) => {
if (v3 && e.target.closest('[data-rrd-close]')) {
e.stopPropagation(); e.preventDefault();
if (hdx && sm && typeof hdx.closeMenuDrawer === 'function') hdx.closeMenuDrawer(e, sm);
return;
}
const b = e.target.closest('[data-rrd-acc]');
if (!b) return;
e.stopPropagation(); e.preventDefault();
const o = b.getAttribute('aria-expanded') === 'true';
const l = document.getElementById(b.getAttribute('aria-controls'));
b.setAttribute('aria-expanded', String(!o));
if (l) l.hidden = o;
if (v3 && b.dataset.nav) send({ nav_location: 'drawer', nav_path: b.dataset.nav + (o ? '#close' : '#open'), link_url: '', link_text: (b.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100) });
}, true);
if (v3 && md && main && sm) {
md.setAttribute('role', 'dialog');
md.setAttribute('aria-modal', 'true');
md.setAttribute('aria-label', dr.getAttribute('aria-label') || 'Menu');
new MutationObserver(() => {
const op = main.hasAttribute('open');
sm.setAttribute('aria-expanded', String(op));
if (!op) return;
let n = 0;
const f = () => {
if (!main.hasAttribute('open') || md.contains(document.activeElement) && document.activeElement !== sm) return;
try { md.focus({ preventScroll: true }); } catch (err) { md.focus(); }
if (document.activeElement !== md && n++ < 10) setTimeout(f, 60);
};
setTimeout(f, 50);
}).observe(main, { attributes: true, attributeFilter: ['open'] });
}
const hd = dr.closest('header-drawer');
if (hd) hd.addEventListener('keydown', (e) => {
if (e.key !== 'Tab') return;
const main = hd.querySelector('details');
const sub = $$('details[open]', main).pop();
const box = sub ? sub.querySelector('.menu-drawer__submenu') : main.hasAttribute('open') ? main : null;
if (!box) return;
const els = $$('summary,a[href],button:enabled,input:not([type=hidden])', box)
.filter((x) => x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden');
const f = els[0], l = els[els.length - 1];
const t = e.shiftKey ? (e.target === f || e.target === box ? l : null) : (e.target === l ? f : null);
if (t) { e.preventDefault(); e.stopPropagation(); t.focus(); }
}, true);
}
document.addEventListener('click', (e) => {
const a = e.target.closest && e.target.closest('[data-rrd-chat]');
if (!a) return;
a._via = '';
const c = document.querySelector('shopify-chat');
const b = c && c.shadowRoot && c.shadowRoot.querySelector('button');
const v3 = !!a.closest('.rd-v3');
const how = !c ? '' : v3 ? (typeof c.show === 'function' ? 'show' : b ? 'button' : ('open' in c) ? 'attr' : '') : (b ? 'button' : '');
if (!how) return;
e.preventDefault();
a._via = how;
const hd = document.querySelector('header-drawer');
const s = hd && hd.querySelector('summary');
if (hd && s && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(e, s);
setTimeout(() => {
try {
if (how === 'show') c.show();
else if (how === 'button') b.click();
else { c.open = true; if (!c.hasAttribute('open')) c.setAttribute('open', ''); }
} catch (err) {
try { if (b && how !== 'button') b.click(); else window.location.href = a.href; } catch (e2) { window.location.href = a.href; }
}
}, 80);
});
document.addEventListener('click', (e) => {
const a = e.target.closest && e.target.closest('a[data-nav]');
if (!a || (e.defaultPrevented && !a.hasAttribute('data-rrd-chat'))) return;
const p = {
nav_location: a.closest('.rrd-drawer') ? 'drawer' : a.closest('.rrd-util') ? 'utility' : 'header',
nav_path: a.dataset.nav,
link_url: a._via ? 'inbox:' + a._via : (a.getAttribute('href') || ''),
link_text: (a.getAttribute('aria-label') || a.innerText || a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100)
};
try {
if (typeof window.gtag === 'function') window.gtag('event', 'nav_click', p);
else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'nav_click' }, p));
} catch (err) {  }
});
})();
